import { render } from "./ManagerPaymentRecord.vue?vue&type=template&id=02c20b8c&scoped=true"
import script from "./ManagerPaymentRecord.vue?vue&type=script&lang=js"
export * from "./ManagerPaymentRecord.vue?vue&type=script&lang=js"

import "./ManagerPaymentRecord.vue?vue&type=style&index=0&id=02c20b8c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c20b8c"]])

export default __exports__